import { useIsUserAnyProductManager } from '@/domain/user/hooks';
import { Role } from '@/domain/user/types';
import { useAuth } from '@/hooks/useAuth';
import { useMemo } from 'react';

import { useRoadmapTypeGroup } from './roadmap';

export const useUserRoadmapTypes = () => {
  const { data: groups = [] } = useRoadmapTypeGroup(true);
  const { data: isPOorPMorTM = false } = useIsUserAnyProductManager();

  const { isLoggedIn, user, isAdmin } = useAuth();

  const isDeveloperOrCustomerCare = useMemo(
    () => user?.roles?.some((role) => role === Role.CustomerCare || role === Role.Developer),
    [user],
  );

  const canOnlyCreateCustomerCare = useMemo(
    () => !isAdmin && !isPOorPMorTM && (isDeveloperOrCustomerCare ?? isLoggedIn),
    [isLoggedIn, isAdmin, isDeveloperOrCustomerCare, isPOorPMorTM],
  );

  const canViewOnboarding = useMemo(
    () => user?.roles?.some((role) => !isAdmin && [!isPOorPMorTM, Role.Onboarding].includes(role)) ?? false,
    [user, isAdmin, isPOorPMorTM],
  );

  const idTypeOnboarding = 1076;

  const filteredGroups = useMemo(() => {
    if (!user) return [];
    if (isAdmin) return groups.filter((r) => !!r.roadmapTypes?.length);

    return groups
      .map((group) => {
        let roadmapTypes = group.roadmapTypes;
        if (canViewOnboarding) {
          roadmapTypes = roadmapTypes?.filter(
            (item) => item.idRoadmapType === idTypeOnboarding || item.customerCare,
          );
        } else if (canOnlyCreateCustomerCare) {
          roadmapTypes = roadmapTypes?.filter((item) => item.customerCare);
        }
        return {
          ...group,
          roadmapTypes,
        };
      })
      .filter((r) => !!r.roadmapTypes?.length);
  }, [canOnlyCreateCustomerCare, canViewOnboarding, groups, isAdmin, user]);

  return { groups: filteredGroups };
};
